import { BulkStats } from '@ps/survey-utils';
import { BulkStatsDto } from '../dtos/bulk-edit.dto';
import { BaseMapper } from '@ps/utils';

export class BulkStatsMapper extends BaseMapper<BulkStatsDto, BulkStats> {
  public override fromDto(dto: BulkStatsDto): BulkStats {
    return {
      fielded: dto.fielded,
      currencySymbol: dto.currency_symbol,
      reconciliationCompletes: dto.rec_complt_count,
      manualFixCompletes: dto.manual_fix_complt_count,
      goal: dto.goal,
      totalCostStats: dto.total_cost,
      cpiStats: dto.cpi,
      loiStats: dto.loi,
    };
  }
}
